
import React from 'react';

import AdminPanel from './components/AdminPanel';
import UserPanel from './components/UserPanel';
import VendorPanel from './components/VendorPanel';
const actor = process.env.REACT_APP_ACTOR;

function App() {
  return (
    <>
    { actor == 'admin'? <AdminPanel/>:'' }
    { (!actor || actor == 'user')? <UserPanel/>:'' }
    { actor == 'vendor'? <VendorPanel/>:'' }
    </>
  )
}

export default App;
